export default {
  entityName: "TaxCode",
  apiEndpoint: "/master/tax-codes",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "Tax Name", sortable: true },
    { key: "code", label: "Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "taxType", label: "Tax Type", sortable: true },
    { key: "rate", label: "Rate (%)", sortable: true, formatter: (val) => `${val}%` },
  ],
  fields: [
    { name: "name", label: "Tax Name", type: "text", required: true, placeholder: "e.g. GST 18%" },
    { name: "code", label: "Code", type: "text", required: true, uppercase: true },
    { name: "taxType", label: "Tax Type", type: "select", required: true, options: ["GST", "CGST", "SGST", "IGST", "CESS", "VAT"] },
    { name: "rate", label: "Rate (%)", type: "number", required: true, min: 0, max: 100 },
    { name: "description", label: "Description", type: "text", fullWidth: true },
    { name: "effectiveFrom", label: "Effective From", type: "date" },
    { name: "effectiveTo", label: "Effective To", type: "date" },
  ],
  filters: [
    { name: "taxType", label: "Tax Type", type: "select", options: ["GST", "CGST", "SGST", "IGST", "CESS", "VAT"] },
  ],
  workflow: {
    type: "tax_code_approval",
    enabled: true,
  },
};
